import { useCallback, useState } from "react"
import { toast } from "react-toastify"
import { getErrorMessage } from "../app/utils/getErrorMessage"

export function useDownloadFile() {
  const [downloading, setDownloading] = useState(false)

  const handleDownload = useCallback(async (downloadLink: string, fileName: string) => {
    try {
      setDownloading(true)

      if (!downloadLink) {
        toast.error("Download link is empty")
        return
      }

      const response = await fetch(downloadLink)

      if (!response.ok) {
        throw new Error("Failed to fetch resource")
      }

      const blob = await response.blob()
      const url = globalThis.URL.createObjectURL(blob)

      const a = document.createElement("a")
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      a.remove()
      globalThis.URL.revokeObjectURL(url)
    } catch (error) {
      toast.error(getErrorMessage(error, "Error downloading file"))
    } finally {
      setDownloading(false)
    }
  }, [])

  return { handleDownload, downloading }
}
